'use client'

export function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id)
    element?.scrollIntoView({ behavior: 'smooth' })
  }

  return (
    <footer className="w-full border-t border-border/50 bg-foreground text-white py-16">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          <div className="space-y-4">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 bg-gradient-to-br from-secondary to-primary rounded-lg flex items-center justify-center">
                <span className="text-white font-bold">A</span>
              </div>
              <span className="font-bold text-lg">Alarvia</span>
            </div>
            <p className="text-sm text-white/70 leading-relaxed">Smart medicine reminders. Built for reliability. Android exclusive.</p>
          </div>
          
          <div className="space-y-4">
            <h4 className="font-bold text-white">Product</h4>
            <ul className="space-y-2 text-sm">
              <li><button onClick={() => scrollToSection('features')} className="text-white/70 hover:text-white transition-colors">Features</button></li>
              <li><button onClick={() => scrollToSection('benefits')} className="text-white/70 hover:text-white transition-colors">Why Alarvia</button></li>
              <li><button onClick={() => scrollToSection('preregister')} className="text-white/70 hover:text-white transition-colors">Pre-Register</button></li>
            </ul>
          </div>
          
          <div className="space-y-4">
            <h4 className="font-bold text-white">Company</h4>
            <ul className="space-y-2 text-sm">
              <li><a href="#" className="text-white/70 hover:text-white transition-colors">About ZeroDevInc</a></li>
              <li><a href="#" className="text-white/70 hover:text-white transition-colors">Contact</a></li>
              <li><a href="#" className="text-white/70 hover:text-white transition-colors">Support</a></li>
            </ul>
          </div>
          
          <div className="space-y-4">
            <h4 className="font-bold text-white">Legal</h4>
            <ul className="space-y-2 text-sm">
              <li><a href="#" className="text-white/70 hover:text-white transition-colors">Privacy Policy</a></li>
              <li><a href="#" className="text-white/70 hover:text-white transition-colors">Terms of Service</a></li>
              <li><a href="#" className="text-white/70 hover:text-white transition-colors">Security</a></li>
              <li><a href="/delete-account" className="text-white/70 hover:text-white transition-colors">Delete Account</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between text-sm">
          <p className="text-white/60">&copy; 2026 ZeroDevInc. All rights reserved.</p>
          <p className="text-secondary font-semibold italic">Care That Remembers.</p>
        </div>
      </div>
    </footer>
  )
}
